'use client';

import {
  createContext,
  type TransitionStartFunction,
  useContext,
  useTransition
} from 'react';

type ContextType = {
  isPending: boolean;
  startTransition: TransitionStartFunction;
};

const CreditApplicationUpdateContext = createContext<ContextType>({
  isPending: false,
  startTransition(callback) {
    callback();
  }
});

export function CreditApplicationUpdateProvider({
  children
}: React.PropsWithChildren) {
  const [isPending, startTransition] = useTransition();

  return (
    <CreditApplicationUpdateContext.Provider
      value={{
        isPending,
        startTransition
      }}
    >
      {children}
    </CreditApplicationUpdateContext.Provider>
  );
}

export function useCreditApplicationUpdate() {
  return useContext(CreditApplicationUpdateContext);
}

export function MockedCreditApplicationUpdateProvider({
  children,
  mockValue
}: React.PropsWithChildren<{ mockValue?: Partial<ContextType> }>) {
  return (
    <CreditApplicationUpdateContext.Provider
      value={{
        isPending: false,
        startTransition(callback) {
          callback();
        },
        ...mockValue
      }}
    >
      {children}
    </CreditApplicationUpdateContext.Provider>
  );
}
